import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var VehicleCCListRes;
export const VehicleCCListTodo = createAsyncThunk('VehicleCCList', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Get",
            url: process.env.REACT_APP_API_URL + 'vehicle_cc',
            params:{
                "vehicle_cc_status ": ""
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return VehicleCCListRes = res.data

    } catch (error) {
        return VehicleCCListRes = error.response.data
    }
})

const VehicleCCListSlice = createSlice({
    name: 'VehicleCCList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(VehicleCCListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(VehicleCCListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default VehicleCCListSlice.reducer; 